<template>
    <div class="modal-card" @click="$emit('selected', {id, title, body})">
        <div class="modal-card-body">
            <b-image src="https://bulma.io/images/placeholders/1280x960.png" alt="placeholder blog" ratio="1by1"></b-image>
            <br>
            <div class="content is-capitalized">
                {{ title }}
            </div>
            <hr>
            <div>
                {{ body }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BlogModal',
    props: ['id', 'title', 'body']
}
</script>

<style>

</style>